import { Theme } from "@mui/material";
import { alpha } from "@mui/system";

const useStyles = (theme: Theme, hideTopBar: boolean, editMode: boolean) => ({
  stacks: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
  },
  boxContainerFilters: (pageTopo: boolean) => ({
    width: "100%",
    flexWrap: "wrap",
    minHeight: "40px",
    height: "fit-content",
    display: { xs: "none", sm: "flex" },
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "start",
    position: "sticky",
    top: hideTopBar ? 0 : 0,
    zIndex: 1000,
    backgroundColor: alpha(theme.palette.background.default, 0.9),
    backDropFilter: "blur(6px)",
    borderBottom: pageTopo ? `1px solid ${theme.palette.divider}` : null,
    paddingY: 2,
    paddingX: 2,
    gap: 2,
  }),
  buttonsContainer: {
    display: "flex",
    gap: 2,
  },
  button: {
    height: "40px",
    maxWidth: "75px",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.primary.light, 0.2)
          : alpha(theme.palette.primary.light, 0.2),
    },
  },
  deleteButton: {
    height: "40px",
    maxWidth: "75px",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.error.main
        : theme.palette.error.dark,
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.error.light
        : theme.palette.error.dark,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.error.light, 0.2)
          : alpha(theme.palette.error.light, 0.2),
    },
  },
  buttonFilter: {
    height: "40px",
    backgroundColor: alpha(theme.palette.background.paper, 1),
    color: theme.palette.text.primary,
    paddingX: 3,
    fontWeight: "bold",
    borderRadius: 1,
  },
  buttonRestore: {
    height: "40px",
    // backgroundColor: alpha(theme.palette.primary.main, 0.1),
    // color: theme.palette.primary.main,
    paddingX: 3,
    fontWeight: "bold",
    borderRadius: 1,
  },
  boxContainerMobile: {
    display: { xs: "flex", sm: "none" },
    flexDirection: "row",
    width: "100%",
    flexWrap: "nowrap",
    minHeight: "40px",
    height: "fit-content",
    justifyContent: "start",
    alignItems: "center",
    position: "sticky",
    top: hideTopBar ? 0 : 0,
    zIndex: 1000,
    backgroundColor: theme.palette.background.default,
    paddingY: 3,
    paddingX: 3,
    gap: 2,
  },
  modal: {
    width: { xs: "100%", sm: "fit-content" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
  },
  boxModalFilters: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    gap: 2,
  },
  select: {
    width: 200,
    backgroundColor: theme.palette.background.paper,
  },
  buttonMobile: {
    width: "100%",
    height: "40px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    boxShadow:
      theme.palette.mode === "light"
        ? `0px 2px 4px ${alpha(theme.palette.text.secondary, 0.2)}`
        : null,
    "&:hover": {
      // color: theme.palette.primary.main,
      boxShadow:
        theme.palette.mode === "light"
          ? `0px 2px 4px ${alpha(theme.palette.text.secondary, 0.2)}`
          : null,
      //backgroundColor: alpha(theme.palette.primary.main, 0.2),
      backgroundColor: alpha(theme.palette.text.secondary, 0.2),
    },
  },
  paperModal: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginX: 5,
    gap: 2,
    padding: 2,
    backgroundColor: theme.palette.background.default,
    borderRadius: 1,
    border: `1px solid ${theme.palette.divider}`,
  },
  boxModal: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    padding: 2,
    borderRadius: 1,
    width: "100%",
    maxWidth: "400px",
    height: "fit-content",
    maxHeight: "80vh",
    overflowY: "auto",
    overflowX: "hidden",
  },
  boxModalHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "fit-content",
    gap: 2,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  boxModalFooter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "center",
    width: "100%",
    height: "fit-content",
    paddingTop: 2,
    gap: 2,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  buttonMenuDawer: {
    color: "white",
    padding: 0.5,
  },
});

export default useStyles;
